<template>
  <div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>

    <div class="footer-placeholder"></div>
    <SafeAreaElement class="footer">
      <div class="footer-wrap">
        <router-link to="/" class="footer-item" :class="{'router-link-exact-active': $route.name === 'homeIndex'}" tag="div" replace>
          <div class="iconfont footer-item-icon" :class="{'iconfont-home-active': $route.name === 'homeIndex', 'iconfont-home': $route.name !== 'homeIndex'}"></div>
          <div class="footer-item-text">{{$t("Discover")}}</div>
        </router-link>
        <router-link to="/my-list" class="footer-item" :class="{'router-link-exact-active': $route.name === 'myList'}" tag="div" replace>
          <div class="iconfont footer-item-icon" :class="{'iconfont-mylist-active': $route.name === 'myList', 'iconfont-mylist': $route.name !== 'myList'}"></div>
          <div class="footer-item-text">{{ $t("MyList") }}</div>
        </router-link>
        <router-link to="/my" class="footer-item" :class="{'router-link-exact-active': $route.name === 'my'}" tag="div" replace>
          <div class="iconfont footer-item-icon" :class="{'iconfont-my-active': $route.name === 'my', 'iconfont-my': $route.name !== 'my'}"></div>
          <div class="footer-item-text">{{ $t("My") }}</div>
        </router-link>
      </div>
    </SafeAreaElement>
  </div>
</template>

<script>
import SafeAreaElement from '@/components/SafeAreaElement';

export default {
  components: {
    SafeAreaElement
  }
};
</script>

<style lang="less" scoped>
.footer-placeholder {
  height: 50px;
}

.footer {
  box-sizing: content-box;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #050505;

  &-wrap {
    display: flex;
    align-items: stretch;
    height: 50px;
    border-top: 0.5px solid #171717;
  }

  &-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-icon {
      width: 24px;
      height: 24px;
      font-size: 24px;
      color: rgba(255,255,255,0.7);
    }

    &-text {
      font-size: 10px;
      color: rgba(255,255,255,0.7);
      
    }

    &.router-link-exact-active {
      .footer-item-text,
      .footer-item-icon {
        color: rgba(255,255,255,0.9);
      }
    }
  }
}
</style>
